Common.mask = () => {
	/* Aplica a máscara nos inputs */
	const maskInputs = $('[data-mask]')
	maskInputs.each(i => {
		const mask = maskInputs.eq(i).attr('data-mask')
		maskInputs.eq(i).mask(mask).attr('maxlength', mask.length);
	})
}
